import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';

import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

import { GoogleOAuthProvider } from '@react-oauth/google';

import './language/i18n'

const persistor = persistStore(store); // 해당 라인 추가

// ⚠️ YOUR_GOOGLE_CLIENT_ID.apps.googleusercontent.com 부분을 본인의 ID로 교체하세요.
const googleClientId = `${process.env.REACT_APP_CLIENT_ID}`;

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <GoogleOAuthProvider clientId={googleClientId}>
          <App />
        </GoogleOAuthProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
